import type { SheetColumn } from "./types";

const normalize = (header: string) =>
  header
    .replace(/\*\s*$/, "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLowerCase();

/**
 * Field name of an imported column header. A header may be the label shown in
 * the template (« Nom de l'entreprise *», accents and case aside) or the field
 * name itself (name), as in older CSV files; unknown headers are kept as-is.
 */
export const headerToKey = <RecordType>(columns: SheetColumn<RecordType>[]) => {
  const keys = new Map<string, string>();
  columns.forEach((column) => {
    keys.set(normalize(column.header), column.key);
    keys.set(normalize(column.key), column.key);
  });
  return (header: string) => keys.get(normalize(header)) ?? header.trim();
};
